var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.call)?_c('div',{staticClass:"call"},[_vm._v(" "+_vm._s(_vm.callText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }